import * as yup from 'yup';

export const combinedSchema = yup.object().shape({
    director_producer: yup.string(),
    metaTitle: yup.string().nullable(),
    
    // Dropdowns (Expect Object or Non-Nullable)
    project_type: yup.object().nullable().required('Project Type is required'),
    program_language: yup.array().min(1).required('Language is required'),
    preferred_shoot_country: yup.array().min(1).required('Shoot Country is required'),
    
    // Text Fields
    project_name: yup.string().required('Project Name is required'),
    director_name: yup.string().required('Director Name is required'),
    producer_name: yup.string().required('Producer Name is required'),
    
    // Dates
    start_date: yup.date()
        .nullable()
        .required('Start Date is required')
        .typeError('Invalid Start Date')
        .when('$isEdit', {
            is: false, // create mode
            then: (schema) => schema.min(new Date(new Date().setHours(0, 0, 0, 0)), "Start Date cannot be in the past"),
            otherwise: (schema) => schema // edit mode → no restriction
        }),
    end_date: yup.date()
        .nullable()
        .required('End Date is required')
        .typeError('Invalid End Date')
        .min(yup.ref('start_date'), "End Date must be after Start Date"),
    
    // Array
    locations: yup.array().of(yup.object().shape({
        pincode: yup.string().nullable(),
        addressLine1: yup.string().nullable(),
        state: yup.string().nullable(),
        district: yup.string().nullable(),
    })),
});